<template>
    <div class="key-data-sup-introduce-audit">
        <div class="title">供应商引入审批</div>
        <SupBaseInfo @showLine="lineVisible = true" v-if="baseInfoVisible" :supplierParams="supplierParams" :auditId="auditId" :moduleCode="moduleCode"/>
        <RiskControlInfo v-if="riskControlInfoVisible" :supplierParams="supplierParams" />
        <RegularLineTable title="常跑线路" :supplierCode="supplierParams.supplierCode" :auditId="auditId" v-if="lineVisible"/>
        <ClientInfo v-if="supplierParams.supplierCode" :supplierCode="supplierParams.supplierCode"/>
    </div>
</template>
<script>
import { getSupByAuditId } from '../../../../../../api/keyDataDetail.js'
import SupBaseInfo from './SupBaseInfo.vue';
import RiskControlInfo from './RiskControlInfo.vue';
import RegularLineTable from './RegularLineTable.vue'
import ClientInfo from './ClientInfo.vue'
export default {
    components: { SupBaseInfo, RiskControlInfo, RegularLineTable, ClientInfo },
    props: {
        auditId: {
            type: String,
            default: ''
        },
        moduleCode: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 供应商信息参数
            supplierParams: {
                id: '',
                businessType: '',
                supplierCode: '',
                propertyNature: '',
            },
            baseInfoVisible: false,
            riskControlInfoVisible: false,
            lineVisible: false,
        };
    },
    methods: {
        setSupplierParams() {
            getSupByAuditId({ auditId: this.auditId }).then(res => {
                if (res && +res.code === 0) {
                    if (res.data) {
                        this.supplierParams.id = res.data.supplierInfoId
                        this.supplierParams.businessType = res.data.businessType
                        this.supplierParams.supplierCode = res.data.supplierCode
                        this.supplierParams.propertyNature = res.data.propertyNature
                    }
                    this.baseInfoVisible = true
                    this.riskControlInfoVisible = true
                }
            }).catch(err => {})
        },
    },
    mounted() {
        this.setSupplierParams()
    },
};
</script>
<style lang="less" scoped>
.key-data-sup-introduce-audit {
    color: #000;

    .title {
        margin-bottom: 15px;
        font-size: 16px;
        font-weight: bold;
    }
}
</style>
